import React from 'react';
import {
	Table,
	message,
	Popconfirm,
	Button,
	Icon,
	Input,
	Select,
	Form,
	Modal,
	Row,
	Col,
	Tooltip,
	Tag,
	Pagination,
	Typography,
	Divider,
	Statistic
} from 'antd';
import {clientLegalPersonAc as Ac} from '../../../redux/actions';
import {connect} from 'react-redux';
import moment from 'moment';

import {server} from '../../../config/serverConfig';
import SearchRender from './SearchRender';
import {download,download2} from "../../../utils";
import {color} from "echarts/src/export";
const { Text } = Typography;
function RenderBase({appRd,story,set, create,get, update,recommend }) {


		//导入本组件所需参数变量
		const {data, dataLoading, dataFetchProps, selectedRows, selectedRowKeys, modalVisible, modalType,  selectedRow, selectedRowIndex,pagination,searchProps,modalRecommendVisible} = story;
		const {loginData,screenType,loginUserRoleAuth} =appRd;
		const {roleid,groupid,user_name} = loginData;

	//dataFetchProps
		if(dataLoading){
			//全局尽量统一通过修改dataLoading来刷新数据，以减少数据不准一。
			// 加载loading
			get({...dataFetchProps,...searchProps});

		}

			//刷新按钮强制刷新，需要提示
		const refreshData =async ()=>{
			let msg =await get({...dataFetchProps,...searchProps});
			message.info(msg);
		}



	//定义表头
		const columns = [{
		  title: 'id',
		  dataIndex: 'id',
		  key: 'id',
		  className: 'align_center', width:50
		},{
		  title: '最新sap编号',
		  dataIndex: 'last_client_id', width:200,
		  key: 'last_client_id',
		},{
			title: '银行名称',
			dataIndex: 'bank_id',
			key: 'bank_id',
			width:200,
			render:text=>text ==='b001'?'锡商行':'其他银行',
		},{
		  title: '法人',
		  dataIndex: 'user_name',
		  key: 'user_name',
		  className: 'align_center', width:180,
		},{
			title: '手机号',
			dataIndex: 'mobile_no',
			key: 'mobile_no',
			className: 'align_center', width:180,
		},{
			title: '是否关联客户',
			dataIndex: 'state',
			key: 'state',
			width:80,
			render:text=>text ==='1'?'是':'否',
		}
		,{
		  title: '授权时间',
		  dataIndex: 'auth_time', width:80,
		  key: 'auth_time',
		  render:(text,record) =>moment(record.auth_time).format('YYYY-MM-DD'),

		},
		];








		const formRenderProps={
		  onFinish(data){
			// 1  先清空分页中原有的当前页，pagination.current =1
			// 2 将搜索内容更新到 searchProps内。
			// 3 更新dataLoading 为true。

			  let  paginationNew = {...pagination}
			  paginationNew.current =1;

		  	  set({dataLoading:true,pagination:{...paginationNew},searchProps:data});
		  }

	  }
		pagination.onChange =(page, pageSize)=>{
			if (isNaN(pageSize) ){
				//这是异常刷新，不记录任何值,比如排序刷新
				return;
			}
			let paginationNew ={...pagination};
			paginationNew.current=page;  //如果page是1，直接提交即可
			paginationNew.pageSize =pageSize;
			set({pagination:paginationNew,dataLoading:true});

		}

		pagination.onShowSizeChange =(current, size)=>{
			let paginationNew ={...pagination};
			let overcount =paginationNew.pageSize * (paginationNew.current-1);

			paginationNew.current  =1 + parseInt(overcount/size);

			paginationNew.pageSize =size;
			set({pagination:paginationNew,dataLoading:true});

		}
		const tableDefinition = {
			rowKey: 'id',
			loading: dataLoading,
			pagination:pagination,
			//size: 'small',
			columns: columns,
			dataSource: data,
			//expandedRowRender: record => <p style={{ margin: 0}}>{JSON.stringify(record,['user_id','mobile','email','roleid','groupid','subgroup','mail_user_rule','mail_grp_rule'])}</p>,
			//rowSelection: rowSelection,
			onRow: (record, index) => { return { onClick: event => set({selectedRow:record, selectedRowIndex: index})}},
			rowClassName: (record, index) => index === selectedRowIndex ? 'selectedItem' : '',
			scroll:{x:800, y: window.innerHeight-370},
		}

	  const modalRenderProps = {

		item: modalType === 'create' ? {} : selectedRow,
		type: modalType,
		visible: modalVisible,
		onOk (data) {
		  set({modalVisible:false})
		  if (modalType === 'create') {
		  	 data.status ='待批准'
			  create(data).then(res=>{
					message.info(res);
			  })
		  }

		  if (modalType === 'update') {
			 update(data, selectedRowIndex).then(res=> {
				return  message.info(res);

			 });

		  }


		},
		onCancel () {
		  set({modalVisible:false})
		},
	  }



	return (
		<div>
			<Row style={{ marginBottom: 10 }}>
			<Col span={24}><Input.Group compact size="large">
				<Button onClick={refreshData}  > <Icon type="sync" style={{color:'green'}} />刷新</Button>


				</Input.Group>

				</Col>

			</Row>
			<Row>
				<Col span={24}>
				<SearchRender {...formRenderProps} />
				</Col>
			</Row>
			  <Table className='logListTable' {...tableDefinition}/>




		</div>);


}

const mapStateToProps = (state) => {
  return {
    story: state.clientLegalPersonRd ,
	appRd: state.appReducer
	}
}

const mapDispatchToProps = (dispatch,ownProps) => {
  return {
	set: (value)=>dispatch(Ac.SET(value)),
	get: (value)=>dispatch(Ac.GET(value)),


	}
}

const ClientRecommend =connect(mapStateToProps,mapDispatchToProps)(RenderBase);

export default ClientRecommend;
